import { render, staticRenderFns } from "./edit-email.vue?vue&type=template&id=0d063b77"
import script from "./edit-email.vue?vue&type=script&lang=ts"
export * from "./edit-email.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports